import { ASSETS } from "@/lib/assets";
import { useI18n } from "@/lib/i18n";
import { SECTIONS } from "@/constants/testIds";

export default function Heritage() {
  const { t } = useI18n();
  return (
    <section
      data-testid={SECTIONS.heritage}
      className="relative bg-[#fbf8f3] text-[#1a1a1a] py-28 lg:py-40 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#7a1a2d]" />
            <span className="text-[11px] tracking-[0.42em] text-[#7a1a2d] uppercase">
              {t.heritage.eyebrow}
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight">
            {t.heritage.title}
          </h2>
          <p className="mt-8 text-[#3a3a3a] leading-relaxed max-w-xl font-light">
            {t.heritage.body1}
          </p>
          <p className="mt-5 text-[#3a3a3a] leading-relaxed max-w-xl font-light">
            {t.heritage.body2}
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
            {[t.heritage.stat1, t.heritage.stat2, t.heritage.stat3].map((s, i) => (
              <div key={i} className="border-l-2 border-[#7a1a2d]/30 pl-4">
                <div className="font-serif text-3xl lg:text-4xl text-[#1a1a1a]">{s.value}</div>
                <div className="mt-1 text-[10px] tracking-[0.28em] uppercase text-[#5a5a5a]">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative aspect-[4/5] w-full overflow-hidden">
            <img
              src={ASSETS.vineyard}
              alt="Vineyard"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 inset-x-0 h-1/3 bg-gradient-to-t from-black/40 to-transparent" />
            <div className="absolute bottom-6 left-6 text-white">
              <div className="text-[10px] tracking-[0.32em] uppercase opacity-80">Jabuka • Pančevo</div>
              <div className="font-serif text-2xl mt-1">Naš vinograd</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
